import logger from "@/utilities/logger";
import { API, errCheck } from './API';
export class MemberManagement {
    async list(obj) {
        try {
            var params = new URLSearchParams(obj).toString();
            return await API().get(`admin/members?${params}`);
        } catch (error) {
            return errCheck(error);
        }
    }

    async delete(data) {
        try {
            return await API().delete(`admin/deletemember/${data}`);
        } catch (error) {
            return errCheck(error);
        }
    }

    async add(data) {
        try {
            return await API().post(`admin/addmember`, data);
        } catch (error) {
            return errCheck(error);
        }
    }

    async edit(id, data) {
        let headers = {
            'Accept-Language': 'ko',
        };
        try {
            return await API().patch(`admin/editmember/${id}`, data, { headers });
        } catch (error) {
            return errCheck(error);
        }
    }

    async view(member_id) {
        try {
            return await API().get(`admin/members/${member_id}`);
        } catch (error) {
            return errCheck(error);
        }
    }

    async changePassword(id, data) {
        try {
            return await API().patch(`admin/members/${id}/change-password`, data);
        } catch (error) {
            return errCheck(error);
        }
    }

    async lookUpAffiliatedCompany(company_id, company_name) {
        try {
            return await API().get(`admin/affiliated/${company_name}/${company_id}`);
        } catch (error) {
            return errCheck(error);
        }
    }

    async changeAffiliatedCompany(data) {
        try {
            return await API().put('admin/change-to-affiliate', data);
        } catch (error) {
            return errCheck(error);
        }
    }

    async download(params, data) {
        try {
            var searchParams = new URLSearchParams(params).toString();
            return await API().post(`admin/memberDownload?${searchParams}`, data, { responseType: 'arraybuffer' });
        } catch (error) {
            return errCheck(error);
        }
    }

    async bulkdelete(data) {
        try {
            return await API().delete(`admin/delete-members`, { data });
        } catch (error) {
            return errCheck(error);
        }
    }

    // 개인정보 마스킹 해제사유 추가
    async addUsersUnmaskLog(data) {
        try {
            // 백엔드 라우터에 설정하신 'admin/unmask-log' 경로로 POST 요청
            return await API().post(`admin/unmask-log`, data);
        } catch (error) {
            return errCheck(error);
        }
    }
}
